import { render } from "./RedesignSlider.vue?vue&type=template&id=205486cf"
import script from "./RedesignSlider.vue?vue&type=script&lang=js"
export * from "./RedesignSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__